/* tslint:disable */
/* eslint-disable */
/* @relayHash 0084c49518bf0689ae0f7e57a63a948f */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NotificationsRefetchQueryVariables = {
    first?: number | null;
    fetchNotifications: boolean;
    hasSessionCountryCode: boolean;
};
export type NotificationsRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"Notifications_viewer">;
    };
};
export type NotificationsRefetchQuery = {
    readonly response: NotificationsRefetchQueryResponse;
    readonly variables: NotificationsRefetchQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchNotifications",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasSessionCountryCode",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "NotificationsRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Notifications_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "fetchNotifications",
                "variableName": "fetchNotifications"
              },
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "hasSessionCountryCode",
                "variableName": "hasSessionCountryCode"
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "NotificationsRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isAutomatedOfferNotificationDisabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disableAutomatedOfferBellNotification"
              }
            ],
            "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
          },
          (v2/*: any*/),
          {
            "kind": "Condition",
            "passingValue": false,
            "condition": "hasSessionCountryCode",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "regInfo",
                "name": "regionalInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "countryCode",
                    "args": null,
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchNotifications",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "conversations",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": "showUnreadOnly"
                  },
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "notifications",
                    "value": true
                  }
                ],
                "concreteType": "ConversationConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ConversationEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Conversation",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "serviceId",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasUnreadMessageForMember",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "apiType",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "inboxImage",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "title",
                                "args": null,
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "latestMessage",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "latestMessageReceivedAt",
                            "args": null,
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "NotificationsRefetchQuery",
    "id": "ferrum/257.0.0-2020-03-23T16:51:22.788Z/NotificationsRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'fff4f5d3a41667f757fb57b758b4e3e8';
export default node;
